import { useQuery } from '@apollo/client'
import { FirmMetadataQuery, MyActiveFirmInfoQuery } from 'api/graphQL/queries/firm.queries'

interface FirmMembership {
    firmId: string
    previewFeatures: string[]
}

interface FirmWithMetadata {
    id: string
    metadata?: {
        created?: string
    }
}

interface UseFirmCreatedDateResult {
    firmCreatedDate: string | null
    loading: boolean
    error: any
}

/**
 * Fetches current firm's creation date using 2-step query (backend schema limitation).
 * Uses `useQuery` with `skip` to preserve Apollo cache across unmount/mount cycles.
 */
export const useFirmCreatedDate = (): UseFirmCreatedDateResult => {
    const { data: membershipData, loading: membershipLoading, error: membershipError } = useQuery<{
        myActiveFirm: FirmMembership
    }>(
        MyActiveFirmInfoQuery,
        {
            fetchPolicy: 'cache-first',
            errorPolicy: 'ignore',
        }
    )

    const { data: firmData, loading: firmLoading, error: firmError } = useQuery<{
        firm: FirmWithMetadata
    }>(
        FirmMetadataQuery,
        {
            variables: { firmId: membershipData?.myActiveFirm?.firmId || '' },
            skip: !membershipData?.myActiveFirm?.firmId,
            fetchPolicy: 'cache-first',
            errorPolicy: 'ignore',
        }
    )

    const firmCreatedDate = firmData?.firm?.metadata?.created || null
    const loading = membershipLoading || firmLoading
    const error = membershipError || firmError

    return {
        firmCreatedDate,
        loading,
        error,
    }
}